// Delegated handlers also work when Shopify re-renders a section in its editor.
document.addEventListener('click', event => {
  const toggle = event.target.closest('.menu-toggle');
  if (!toggle) return;
  const menu = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!menu) return;
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  toggle.setAttribute('aria-expanded', String(open));
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  menu.hidden = !open;
});
document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-selector]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const container = select.closest('.product-info');
  if (!container || !option) return;
  const price = container.querySelector('[data-product-price]');
  const sku = container.querySelector('[data-product-sku]');
  const button = container.querySelector('[data-add-button]');
  if (price) price.textContent = option.dataset.price;
  if (sku) sku.textContent = option.dataset.sku || '—';
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'SOLD OUT' : 'ADD TO CART ↗';
  }
});

// Native scrolling keeps the images usable on touch screens and without scripts.
if (!customElements.get('mathers-carousel')) {
  customElements.define('mathers-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.items = Array.from(this.track.querySelectorAll('[data-carousel-item]'));
      this.previous = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.status = this.querySelector('[data-carousel-status]');
      this.index = 0;
      this.position = item => item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.go = index => {
        const item = this.items[Math.max(0, Math.min(index, this.items.length - 1))];
        if (!item) return;
        this.track.scrollTo({left: this.position(item), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.update = () => {
        if (!this.items.length) return;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const left = this.track.scrollLeft;
        this.index = this.items.reduce((best, item, i) => Math.abs(this.position(item) - left) < Math.abs(this.position(this.items[best]) - left) ? i : best, 0);
        if (this.previous) this.previous.disabled = left <= 2;
        if (this.next) this.next.disabled = left >= max - 2;
        this.items.forEach((item, i) => {
          const video = item.querySelector('.hero-background-video');
          if (!video) return;
          if (i === this.index && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            if (video.paused) video.play().catch(() => {});
          } else if (!video.paused) video.pause();
        });
        if (this.status) {
          const visible = this.items.map((item, i) => {
            const x = this.position(item);
            return x < left + this.track.clientWidth - 3 && x + item.offsetWidth > left + 3 ? i + 1 : null;
          }).filter(Boolean);
          const label = visible.length > 1 ? visible[0] + '–' + visible[visible.length - 1] : String(visible[0] || 1);
          const text = label + ' / ' + this.items.length;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
        const controls = this.querySelector('[data-carousel-controls]');
        if (controls) controls.hidden = max <= 2;
      };
      if (this.previous) this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-carousel-item]');
        const i = this.items.indexOf(item);
        if (i >= 0) this.go(i);
      }, options);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.frame = requestAnimationFrame(this.update);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}